// src/data/commands.js
const commandList = [
  {
    name: '/코인',
    description: '현재 보유중인 코인을 확인합니다.(텍스트 명령어 사용 가능)',
    category: '미니게임',
    path: '/docs/game/coin',
  },
  {
    name: '/코인받기',
    description: '1분마다 5만 코인을 지급받습니다.',
    category: '미니게임',
    path: '/docs/game/getcoin',
  },
  {
    name: '/추천',
    description: '12시간 간격으로 각 사이트 추천 시 50만 코인을 지급합니다.(텍스트 명령어 사용 가능)',
    category: '미니게임',
    path: '/docs/game/vote',
  },
  {
    name: '/통계',
    description: '게임 명령어의 통계를 확인합니다.(텍스트 명령어 사용 가능)',
    category: '미니게임',
    path: '/docs/game/state',
  },
  {
    name: '/도박',
    description: '코인으로 게임을 즐길 수 있습니다.(텍스트 명령어 사용 가능)',
    category: '미니게임',
    path: '/docs/game/dobak',
  },
  {
    name: '/주사위',
    description: '코인으로 주사위게임을 합니다.(텍스트 명령어 사용 가능)',
    category: '미니게임',
    path: '/docs/game/dice',
  },
  {
    name: '/가위바위보',
    description: '코인으로 가위바위보를 합니다.(텍스트 명령어 사용 가능)',
    category: '미니게임',
    path: '/docs/game/rsp',
  },
  {
    name: '/그래프',
    description: '코인을 배팅하여 그래프 게임을 시작합니다.(텍스트 명령어 사용 가능)',
    category: '미니게임',
    path: '/docs/game/grp',
  },
  {
    name: '/블랙잭',
    description: '코인을 배팅하여 블랙잭 게임을 시작합니다.(텍스트 명령어 사용 가능)',
    category: '미니게임',
    path: '/docs/game/blackjack',
  },
  {
    name: '/순위',
    description: '코인 보유 순위를 확인합니다.',
    category: '미니게임',
    path: '/docs/game/rank',
  },



  {
    name: '/옵치 영웅',
    description: '오버워치의 영웅 정보를 확인합니다.',
    category: '오버워치',
    path: '/docs/overwatch/hero',
  },
  {
    name: '/옵치 등록',
    description: '오버워치 배틀태그를 저장합니다.',
    category: '오버워치',
    path: '/docs/overwatch/owregister',
  },
  {
    name: '/옵치 티어',
    description: '오버워치 티어 등 종합 정보를 확인합니다.',
    category: '오버워치',
    path: '/docs/overwatch/tier',
  },
  {
    name: '/옵치 정보',
    description: '오버워치의 전적을 확인합니다.',
    category: '오버워치',
    path: '/docs/overwatch/info',
  },
  {
    name: '/옵치 내전',
    description: '티어 및 전적을 기준으로 자동으로 팀을 구성합니다.',
    category: '오버워치',
    path: '/docs/overwatch/team',
  },
  {
    name: '/옵치 분석',
    description: '경쟁전 기록, 티어를 기준으로 분석 및 조언을 확인할 수 있습니다.',
    category: '오버워치',
    path: '/docs/overwatch/analyze',
  },





  
  {
    name: '/시세',
    description: '아이템 시세를 확인합니다.',
    category: '타르코프',
    path: '/docs/tarkov/price',
  },
  {
    name: '/지도',
    description: '타르코프 지도를 확인합니다.',
    category: '타르코프',
    path: '/docs/tarkov/map',
  },





  {
    name: '/급식 등록',
    description: '학교를 검색하여 등록합니다.',
    category: '급식',
    path: '/docs/meal/register',
  },
  {
    name: '/급식 확인',
    description: '등록한 학교의 급식을 확인합니다.',
    category: '급식',
    path: '/docs/meal/check',
  },



  
  {
    name: '/커스텀 확인',
    description: '커스텀 명령어 목록을 확인합니다.',
    category: '커스텀 봇',
    path: '/docs/custom/check',
  },
  {
    name: '/커스텀 생성',
    description: '커스텀 명령어를 생성합니다.',
    category: '커스텀 봇',
    path: '/docs/custom/create',
  },
  {
    name: '/커스텀 수정',
    description: '커스텀 명령어를 수정합니다.',
    category: '커스텀 봇',
    path: '/docs/custom/edit',
  },
  {
    name: '/커스텀 삭제',
    description: '커스텀 명령어를 삭제합니다.',
    category: '커스텀 봇',
    path: '/docs/custom/delete',
  },
  {
    name: '/커스텀 설정',
    description: '커스텀 봇 이름, 프로필사진을 수정합니다.',
    category: '커스텀 봇',
    path: '/docs/custom/setting',
  },



  {
    name: '/도움말',
    description: '전적이에서 사용할 수 있는 모든 명령어들을 정리한 도움말입니다.',
    category: '기타',
    path: '/docs/etc/help',
  },
  {
    name: '/접두사변경',
    description: '해당서버의 택스트명령어 접두사를 변경합니다.',
    category: '기타',
    path: '/docs/etc/prefix',
  },
  {
    name: '@전적이(멘션)',
    description: '해당 서버의 접두사를 확인합니다.',
    category: '기타',
    path: '/docs/etc/checkprefix',
  },
  
  {
    name: '마법의 전적이님',
    description: '마법의 전적이에게 물어봅니다.',
    category: '기타',
    path: '/docs/etc/magicconch',
  },
  
];

export default commandList;